import { Switch as SwitchInput } from "react-aria-components";
import clsx from "clsx";

import styles from "./switch.module.css";

interface SwitchProps {
  defaultSelected?: boolean;
  isSelected: boolean;
  value: string;
  className?: string;
  label: string;
  isDisabled?: boolean;
  name: string;
  autoFocus?: boolean;
  onChange?: (isSelected: boolean) => void;
  display?: {
    orientation?: "row" | "row-reverse" | "column";
  };
}

function Switch({
  className,
  defaultSelected,
  isSelected,
  value,
  label,
  isDisabled,
  autoFocus,
  name,
  onChange,
  display,
}: SwitchProps) {
  const orientation = display?.orientation || "column";
  return (
    <SwitchInput
      className={clsx(styles.switch, className, {
        [styles.column]: orientation === "column",
        [styles.rowReverse]: orientation === "row-reverse",
      })}
      onChange={onChange}
      defaultSelected={defaultSelected}
      isSelected={isSelected}
      value={value}
      isDisabled={isDisabled}
      autoFocus={autoFocus}
      name={name}
    >
      <div className={styles.indicator} />
      {label}
    </SwitchInput>
  );
}

export default Switch;
